
<script>
import New from './New8'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
